import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-center justify-content-sm-between align-items-center text-center flex-wrap gap-2 showing-wrap" }
const _hoisted_2 = { class: "fs-12 fw-medium" }
const _hoisted_3 = { "aria-label": "Page navigation example" }
const _hoisted_4 = { class: "pagination mb-0 justify-content-center" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 1,
  class: "page-link disabled"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, " Showing " + _toDisplayString(_ctx.items) + " of " + _toDisplayString(_ctx.total) + " Results ", 1),
    _createElementVNode("nav", _hoisted_3, [
      _createElementVNode("ul", _hoisted_4, [
        _createElementVNode("li", {
          class: _normalizeClass(['page-item', { disabled: _ctx.currentPage === 1 }])
        }, [
          _createElementVNode("a", {
            class: "page-link icon",
            href: "#",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args)), ["prevent"])),
            "aria-label": "Previous"
          }, _cache[2] || (_cache[2] = [
            _createElementVNode("i", { class: "material-symbols-outlined" }, "keyboard_arrow_left", -1)
          ]))
        ], 2),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedPages, (page) => {
          return (_openBlock(), _createElementBlock("li", {
            key: page,
            class: _normalizeClass(['page-item', { active: page === _ctx.currentPage }])
          }, [
            (page !== '...')
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: "page-link",
                  href: "#",
                  onClick: _withModifiers(($event: any) => (_ctx.goToPage(page)), ["prevent"])
                }, _toDisplayString(page), 9, _hoisted_5))
              : (_openBlock(), _createElementBlock("span", _hoisted_6, "..."))
          ], 2))
        }), 128)),
        _createElementVNode("li", {
          class: _normalizeClass(['page-item', { disabled: _ctx.currentPage === _ctx.totalPages }])
        }, [
          _createElementVNode("a", {
            class: "page-link icon",
            href: "#",
            onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)), ["prevent"])),
            "aria-label": "Next"
          }, _cache[3] || (_cache[3] = [
            _createElementVNode("i", { class: "material-symbols-outlined" }, "keyboard_arrow_right", -1)
          ]))
        ], 2)
      ])
    ])
  ]))
}